import { gql } from 'graphql-request';
import { TaxonomySummary } from 'src/shared/types/graph/project';

// Query a minimal subset of species map data needed for Site Key Metrics
export const siteKeyMetricsSpeciesQuery = gql`
    query getSiteKeyMetricsSpecies($projectId: String!, $samples: sampleFilter) {
        siteKeyMetricsSpecies: project(projectId: $projectId, samples: $samples) {
            taxonomySummary {
                taxonomy {
                    tax_species
                    common_name
                }
                conservationStatus {
                    iucnRedListStatus
                    onGRIISList
                }
                sampleCount
                percentTotalSamples
                nmSeqId
            }
        }
    }
`;

export type SiteKeyMetricsSpeciesData = {
    taxonomySummary: TaxonomySummary;
};

export type SiteKeyMetricsSpeciesQueryResult = {
    siteKeyMetricsSpecies: SiteKeyMetricsSpeciesData;
};
